var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center py-4"},[_c('Icon-Empty',{staticClass:"w-16 h-16"}),_c('p',{staticClass:"font-thin pt-4 text-xl text-center",domProps:{"textContent":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }